import InitializingApplication from '@app/components/InitilizingApplication';
import { initialApp } from '@app/modules/app-initial/app-initial';

import '@app/modules/app-initial/app-setting';

import React, { Suspense } from 'react';
import CommonToast from '@app/components/CommonToast';
import { store } from '@app/features/store';
import { primereactConfig } from '@app/modules/app-theme';
import { LocalesProvider } from '@app/modules/i18n-locales';
import AppRouterProvider from '@app/modules/routes/components/AppRouterProvider';
import { PrimeReactProvider } from 'primereact/api';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import pkg from '../package.json';

import '@styles/globals.scss';
import '@styles/layout/layout.scss';

export const appInfo = {
  appVersion: pkg.version,
  api: import.meta.env.VITE_API_ENDPOINT,
  env: import.meta.env.VITE_ENV,
};

const root = ReactDOM.createRoot(document.getElementById('root')! as HTMLElement);

(async () => {
  await initialApp();

  root.render(
    <Suspense>
      <Provider store={store}>
        <LocalesProvider>
          <PrimeReactProvider value={primereactConfig}>
            <CommonToast />
            <AppRouterProvider />
          </PrimeReactProvider>
        </LocalesProvider>
      </Provider>
    </Suspense>
  );
})();
